import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import InfiniteScroll from '../../../infinite-scroll/InfiniteScroll'
import Activity from '../../../activity/Activity'
import classes from './ActivityFeed.module.scss'
import ActivityAnnouncement from '../../../activity/ActivityAnnouncementCard'
import PostAnnouncementButton from '../../../dashboard/coachDashboard/PostAnnouncementButton'
import PostAnnouncementModal from '../../../dashboard/coachDashboard/PostAnnouncementModal'
import ActivitySkeleton from '../../../activity/ActivitySkeleton'
import HorizontalSelector from './HorizontalSelector'
import classNames from 'classnames'
import { ReactComponent as PlaceholderIcon } from '../../../../assets/images/common/icons/chat-boxes-icon.svg'
import { addSelectedProgram, resetSelectedData } from '../../../../reducers/programDashboardReducer'

const PER_PAGE = 6

const ActivityFeed = ({ id, loadingFeedActivities, activitiesTotalPages,
  clearActivities, getActivities, feedActivities, removeActivity, isProgram }) => {
  const [collapsed, setCollapsed] = useState(false)
  const [postAnnouncementModal, setPostAnnouncementModal] = useState(false)
  const [page, setPage] = useState(0)
  const [filter, setFilter] = useState('all')
  const program = useSelector(state => state.programDashboard.program)
  const location = useLocation()
  const { t } = useTranslation()


  const filters = [
    { label: t('programs.manage.activityFeed.filters.all'), key: 'all' },
    { label: t('programs.manage.activityFeed.filters.announcement'), key: 'announcement' },
    { label: t('programs.manage.activityFeed.filters.play'), key: 'play' },
    { label: t('programs.manage.activityFeed.filters.train'), key: 'train' },
    { label: t('programs.manage.activityFeed.filters.event'), key: 'event' },
  ]

  const dispatch = useDispatch()

  const fetchActivities = () => {
    dispatch(getActivities({ id: id, page: page + 1, perPage: PER_PAGE, type: filter }))
    setPage((prevState) => prevState + 1)
  }

  const onChangeFilter = (value) => {
    if (value === filter) { return }
    setFilter(value)
    setPage(0)
    dispatch(clearActivities())
  }

  useEffect(() => {
    fetchActivities()
    if (window.innerWidth < 1200) {
      setCollapsed(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  useEffect(() => {
    if (location.state?.openModal) {
      setPostAnnouncementModal(true)
    }
  }, [location.state?.openModal])

  const handleModalClose = () => {
    setPostAnnouncementModal(false)
    dispatch(resetSelectedData())
  }

  const activitySkeletons = () => (
    <div className={classNames('d-flex flex-column align-items-center', classes.feedContainer, classes.loadingSection)}>
      <ActivitySkeleton />
      <ActivitySkeleton />
      <ActivitySkeleton />
    </div>)

  const placeholder = () =>
    <div className={classNames('d-flex flex-column align-items-center', classes.feedContainer)}>
      <PlaceholderIcon className='mt-5' />
      <div className={classes.placeholderTitle}>
        {t('programs.manage.activityFeed.placeholder.title')}
      </div>
      <div className={classes.placeholderText}>
        {t('programs.manage.activityFeed.placeholder.text')}
      </div>
    </div>


  const isFirstPageLoading = loadingFeedActivities && page <= 1

  const openPostAnnouncementModal = () => {
    setPostAnnouncementModal(true)

    if (isProgram) {
      dispatch(addSelectedProgram(program))
    }
  }

  return (
    <div
      className={classnames(classes.communityFeed, { [classes.collapsed]: collapsed })}
      onClick={() => collapsed && setCollapsed(false)}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        e.key === 'Enter' && collapsed && setCollapsed(false)
      }}
    >

      {
        <div className={classes.arrowWrapper}>
          <button className={classes.arrowButton} style={{ transform: collapsed ? 'rotate(180deg)' : 'none' }} onClick={() => setCollapsed(true)} />
        </div>}
      <PostAnnouncementModal onClose={handleModalClose} isOpen={postAnnouncementModal} isProgram={isProgram}/>
      {!collapsed && (<PostAnnouncementButton openModal={openPostAnnouncementModal}/>)}
      {!collapsed && (<HorizontalSelector tabs={filters} onSelect={onChangeFilter} />)}
      {!collapsed && isFirstPageLoading && activitySkeletons() }
      {!collapsed && feedActivities.length === 0 && placeholder()}
      {!collapsed && feedActivities.length > 0 &&
        <div className={classes.feedContainer} id='feedContainer'>
          <InfiniteScroll
            dataLength={feedActivities.length}
            next={fetchActivities}
            hasMore={activitiesTotalPages >= page}
            loaderClassName={classes.loader}
            scrollableTarget='feedContainer'
          >
            {feedActivities.map((activity) => activity.type === 'ActivityAnnouncement' ?
              <ActivityAnnouncement
                key={activity.id}
                activity={activity}
                removeActivity={removeActivity}
                isProgram={isProgram}
              /> :
              <Activity
                key={activity.id}
                displayComments={false}
                activity={activity}
                isStudentJourney
              />
            )}
          </InfiniteScroll>
        </div>
      }
    </div>
  )
}

ActivityFeed.propTypes = {
  id: PropTypes.number,
  loadingFeedActivities: PropTypes.bool,
  activitiesTotalPages: PropTypes.number,
  fetchActivities: PropTypes.func,
  clearActivities: PropTypes.func,
  getActivities: PropTypes.func,
  feedActivities: PropTypes.array,
  removeActivity: PropTypes.func,
  isProgram: PropTypes.bool,
}

export default ActivityFeed
